import { useOrderSearchHighlightTerm } from '~components/OrderSearchHighlightContext/OrderSearchHighlightContext';
import { Order } from '~hooks/useOrders/models';
import { useStores } from '~store';
import { deriveOrderSearchMatchFields } from '~utils/orderSearchMatches';

// Not memoized: `upsertJob` splices updated jobs into the same array, so a memo keyed on it
// would go stale. Callers are observers and re-render when that array mutates.
export default function useOrderSearchMatches(order: Order) {
  const { ordersDispatchStore } = useStores();
  const searchTerm = useOrderSearchHighlightTerm();

  return deriveOrderSearchMatchFields(
    order,
    ordersDispatchStore.orderJobs.get(order.id) ?? [],
    searchTerm,
  );
}
